class BundleDrawer extends DrawerElement {
  constructor() {
    super();

    this.dirty = false;
    this.cachedMap = new Map();

    this.collectionUrl =
      location.origin + this.getAttribute("data-collection-url");
  }

  get shouldAppendToBody() {
    return false;
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  connectedCallback() {
    super.connectedCallback();
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);
  }

  sort(sortBy, event) {
    const url = new URL(this.collectionUrl);
    url.searchParams.set("sort_by", sortBy);
    url.searchParams.set("view", "bundle-drawer");
    this.renderSection(url.toString(), event);
  }

  search() {
    const query = this.input.value.trim().toLowerCase();
    const container = document.getElementById("BundleItemGridContainer");
    const items = container.querySelectorAll(".bundle-item");

    if (query.length === 0) {
      items.forEach((item) => {
        item.style.display = "flex";
      });
      return;
    }

    items.forEach((item) => {
      if (
        item
          .querySelector("[data-item-title]")
          .innerText.toLowerCase()
          .includes(query)
      ) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });
  }

  renderSection(url, event) {
    this.cachedMap.has(url)
      ? this.renderSectionFromCache(url, event)
      : this.renderSectionFromFetch(url, event);

    this.dirty = false;
  }

  renderSectionFromFetch(url, event) {
    this.beforeRenderSection();
    const start = performance.now();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const execution = performance.now() - start;

        setTimeout(
          () => {
            this.renderBundleItemGridContainer(responseText);
            this.renderSortBy(responseText);
            this.renderModals(responseText);

            this.cachedMap.set(url, responseText);
            this.afterRenderSection();
          },
          execution > 500 ? 0 : 500
        );
      });
  }

  renderSectionFromCache(url, event) {
    this.beforeRenderSection();

    setTimeout(() => {
      const responseText = this.cachedMap.get(url);
      this.renderBundleItemGridContainer(responseText);
      this.renderSortBy(responseText);
      this.renderModals(responseText);
      this.afterRenderSection();
    }, 500);
  }

  beforeRenderSection() {
    const container = document.getElementById("BundleItemGridContainer");
    const items = container.querySelectorAll(".bundle-item");
    const translateY = theme.config.motionReduced ? 0 : 50;

    Motion.timeline([
      [
        items,
        { y: translateY, opacity: 0, visibility: "hidden" },
        {
          duration: 0.5,
          delay: theme.config.motionReduced ? 0 : Motion.stagger(0.1),
        },
      ],
      [
        container,
        { y: translateY, opacity: 0 },
        { duration: 0.5, easing: "linear" },
      ],
    ]);
  }

  afterRenderSection() {
    const container = document.getElementById("BundleItemGridContainer");
    const items = container.querySelectorAll(".bundle-item");
    const translateY = theme.config.motionReduced ? 0 : 50;

    Motion.timeline([
      [
        container,
        { y: [translateY, 0], opacity: [0, 1] },
        { duration: 0.5, easing: "linear" },
      ],
      [
        items,
        {
          y: [translateY, 0],
          opacity: [0, 1],
          visibility: ["hidden", "visible"],
        },
        {
          duration: 0.5,
          delay: theme.config.motionReduced ? 0 : Motion.stagger(0.1),
        },
      ],
    ]);
  }

  renderBundleItemGridContainer(responseText) {
    const id = "BundleItemGridContainer";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );
    parsedHTML.querySelector("motion-list").setAttribute("motion-reduced", "");

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id).innerHTML;

    this.search();
  }

  renderSortBy(responseText) {
    const id = "BundleSortByContainer";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id).innerHTML;
  }

  renderModals(responseText) {
    const id = "BundleModalsContainer";
    if (document.getElementById(id) === null) return;
    const parsedHTML = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    document.getElementById(id).innerHTML =
      parsedHTML.getElementById(id).innerHTML;
  }
}
customElements.define("bundle-drawer", BundleDrawer);

class BundleFacetSort extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), {
      margin: "200px 0px 200px 0px",
    });

    this.addEventListener("change", this.onChange);
    this.button.addEventListener("click", this.show.bind(this));
    this.close.addEventListener("click", this.hide.bind(this));
    document.addEventListener("click", this.onWindowClick.bind(this));
  }

  get listbox() {
    return this.querySelector(".sort-listbox");
  }

  get selection() {
    return this.querySelector(".sort-selection");
  }

  get button() {
    return this.querySelector(".sort-by");
  }

  get close() {
    return this.querySelector(".sort-close");
  }

  init() {
    this.initButton();
    this.style.setProperty(
      "--facet-listbox-height",
      `${this.listbox.getBoundingClientRect().height}px`
    );
  }

  initButton() {
    const value = this.selection.innerText;
    const width = theme.getElementWidth(this.selection, value);
    this.style.setProperty("--facet-button-width", `${width}px`);
  }

  onChange(event) {
    const drawer =
      this.closest("bundle-drawer") || document.querySelector("bundle-drawer");

    if (drawer) {
      const sortBy = event.target.value;
      drawer.sort(sortBy, event);
    }

    this.selection.innerText = event.target.nextElementSibling.innerText;
    this.initButton();
    this.hide();
  }

  show() {
    this.button.setAttribute("open", "");
  }

  hide(immediate = true) {
    if (this.button.hasAttribute("open")) {
      const btnFill = this.button.querySelector("[data-fill");
      Motion.animate(
        btnFill,
        { y: ["0%", immediate ? "0%" : "-76%"] },
        { duration: 0.6, delay: immediate ? 0 : 0.2 }
      );

      setTimeout(() => {
        this.button.removeAttribute("open");
      }, 100);
    }
  }

  onWindowClick(event) {
    if (!this.contains(event.target)) {
      if (this.button.hasAttribute("open")) {
        this.hide(false);
      }
    }
  }
}
customElements.define("bundle-facet-sort", BundleFacetSort);

class BundleSearch extends HTMLFormElement {
  constructor() {
    super();

    this.focusElement = this.input;

    this.resetButton.addEventListener("click", this.clear.bind(this));
    this.input.addEventListener("click", this.hideTypewriter.bind(this));
    this.input.addEventListener(
      "input",
      theme.utils.debounce(this.onChange.bind(this), 300)
    );

    this.events = {
      afterHide: "modal:afterHide",
      afterShow: "modal:afterShow",
    };
  }

  static get observedAttributes() {
    return ["open"];
  }

  get controls() {
    return Array.from(
      document.querySelectorAll(`[aria-controls="${this.id}"]`)
    );
  }

  get open() {
    return this.hasAttribute("open");
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get typewriter() {
    return this.input.previousElementSibling;
  }

  get designMode() {
    return this.hasAttribute("shopify-design-mode");
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.controls.forEach((button) =>
      button.addEventListener("click", this.onToggle.bind(this), {
        signal: this.abortController.signal,
      })
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  onToggle(event) {
    event.preventDefault();

    this.open ? this.hide() : this.show(event.currentTarget);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "open":
        this.controls.forEach((button) =>
          button.setAttribute(
            "aria-expanded",
            newValue === null ? "false" : "true"
          )
        );

        if (
          oldValue === null &&
          (newValue === "" || newValue === "immediate")
        ) {
          this.removeAttribute("inert");

          const showTransitionPromise =
            this.showTransition(newValue !== "immediate") || Promise.resolve();
          showTransitionPromise.then(() => {
            this.afterShow();
            this.dispatchEvent(
              new CustomEvent(this.events.afterShow, { bubbles: true })
            );
          });
        } else if (oldValue !== null && newValue === null) {
          this.setAttribute("inert", "");

          const hideTransitionPromise =
            this.hideTransition() || Promise.resolve();
          hideTransitionPromise.then(() => {
            this.afterHide();

            if (!this.hasAttribute("inert")) return;

            this.dispatchEvent(
              new CustomEvent(this.events.afterHide, { bubbles: true })
            );
          });
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));

        break;
    }
  }

  hide() {
    this.beforeHide();
    this.removeAttribute("open");
  }

  show(activeElement = null, animate = true) {
    if (this.open) return;

    this.beforeShow();
    this.activeElement = activeElement;
    this.setAttribute("open", animate ? "" : "immediate");

    return theme.utils.waitForEvent(this, this.events.afterShow);
  }

  beforeHide() {}
  beforeShow() {}

  afterHide() {
    setTimeout(() => {
      theme.a11y.removeTrapFocus(this.activeElement);
    });
  }
  afterShow() {
    theme.a11y.trapFocus(this, this.focusElement);
  }

  hideTypewriter() {
    if (this.typewriter && !this.typewriter.hasAttribute("hidden")) {
      this.typewriter.setAttribute("hidden", "");
    }
  }

  showTransition() {
    setTimeout(() => {
      this.setAttribute("active", "");
    }, 75);
    return new Promise((resolve) => {
      resolve();
    });
  }
  hideTransition() {
    this.removeAttribute("active");
    return new Promise((resolve) => {
      resolve();
    });
  }

  clear(event = null) {
    if (event) event.preventDefault();

    this.input.value = "";
    this.input.focus();

    const drawer = document.querySelector("bundle-drawer");
    if (drawer) {
      drawer.search("");
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }

    this.hideTypewriter();

    const drawer = document.querySelector("bundle-drawer");
    if (drawer) {
      drawer.search(this.getQuery());
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.onChange();
  }
}
customElements.define("bundle-search", BundleSearch, {
  extends: "form",
});

class BundleProductForm extends HTMLFormElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.addEventListener("submit", this.onSubmitHandler.bind(this), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get bundleDrawer() {
    return this.closest(".bundle-drawer");
  }

  get bundleModal() {
    return this.closest(".bundle-modal");
  }

  get bundleBuilder() {
    return document.querySelector("bundle-builder");
  }

  get currentVariant() {
    return document.querySelector(
      `variant-radios[form="${this.getAttribute("id")}"]`
    ).currentVariant;
  }

  get submitButton() {
    return this.querySelector('[type="submit"]');
  }

  onSubmitHandler(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.submitButton.hasAttribute("aria-disabled")) return;

    this.submitButton.setAttribute("aria-disabled", "true");
    this.submitButton.setAttribute("aria-busy", "true");

    this.bundleBuilder?.dispatchEvent(
      new CustomEvent("bundle:product:submit", {
        bubbles: true,
        detail: {
          variant: this.currentVariant,
        },
      })
    );

    this.submitButton.removeAttribute("aria-disabled");
    this.submitButton.removeAttribute("aria-busy");

    if (this.bundleModal) {
      document.body.addEventListener(
        "modal:afterHide",
        () => {
          this.bundleDrawer?.hide();
        },
        { once: true }
      );
      this.bundleModal.hide(true);
    }
  }
}
customElements.define("bundle-product-form", BundleProductForm, {
  extends: "form",
});

class BundleBuilder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.shouldRestoreState) {
      this.restoreState();
    }

    this.abortController = new AbortController();

    this.productForm.addEventListener(
      "productInfo:loaded",
      this.onVariantChange.bind(this),
      { signal: this.abortController.signal }
    );

    this.addEventListener(
      "bundle:product:submit",
      this.onProductSubmit.bind(this),
      { signal: this.abortController.signal }
    );

    document.addEventListener(
      "DOMContentLoaded",
      () => {
        this.updateProgress();
        this.updatePrice();
        this.updateBuyButton();
        if (this.quantitySelector) {
          this.quantitySelector.style.display = "none";
        }
      },
      { once: true }
    );

    this.saveState();
  }

  get stateTtl() {
    return parseInt(this.getAttribute("data-state-ttl"));
  }

  get selectedCount() {
    return Math.min(
      this.items.filter((item) => item.isSelected && !item.isOptional).length,
      this.totalCount
    );
  }

  get shouldRestoreState() {
    return this.getAttribute("data-restore-state") === "true";
  }

  restoreState() {
    this.removeAttribute("data-restore-state");

    const state = this.state;
    if (!state) return;

    const parsedHTML = new DOMParser().parseFromString(state, "text/html");

    const bundleItemList = parsedHTML.querySelector(".bundle-item-list");
    if (bundleItemList) {
      this.itemListElement.innerHTML = bundleItemList.innerHTML;
    }

    const alertElement = parsedHTML.querySelector(".bundle-alert");
    if (alertElement) {
      this.alertElement.replaceWith(alertElement);
    }
  }

  saveState() {
    this.state = this.innerHTML;
  }

  get state() {
    if (this._state) return this._state;

    const itemStr = localStorage.getItem(
      `bundleBuilderState-${this.productId}`
    );
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(`bundleBuilderState-${this.productId}`);
      return null;
    }

    return (this._state = item.value);
  }

  set state(value) {
    const now = new Date();
    const ttl = this.stateTtl * 60 * 1000;
    const expiry = now.getTime() + ttl;
    const item = {
      value,
      expiry,
    };

    localStorage.setItem(
      `bundleBuilderState-${this.productId}`,
      JSON.stringify(item)
    );

    this._state = value;
  }

  beforeSubmit(formData) {
    this.bundleId = crypto.randomUUID();
    formData.append(`properties[_bundle_id]`, this.bundleId);
    const nonOptionalItems = this.items.filter(
      (item) => !item.isOptional && !item.isPreselected
    );
    nonOptionalItems.forEach((item, i) => {
      formData.append(
        `properties[_variant_sku_${i + 1}]`,
        item.variantData.sku
      );
      formData.append(
        `properties[_variant_name_${i + 1}]`,
        item.variantData.name
      );
      formData.append(
        `properties[${theme.bundleBuilderStrings.properties.product} ${i + 1}]`,
        item.variantData.name
      );
      let newSrc = null;
      try {
        newSrc = new URL("https:" + item.variantData.featured_image?.src);
        newSrc.searchParams.set("width", "200");
      } catch (error) {
        console.error("Error setting image src", error);
      }
      formData.append(`properties[_variant_image_${i + 1}]`, newSrc);
    });
  }

  async onSubmit(quantity = 1, sections, sectionsUrl) {
    const optionalSelectedItems = this.items.filter(
      (item) => item.isOptional && item.isSelected
    );
    if (optionalSelectedItems.length === 0) return;

    const config = theme.utils.fetchConfig("javascript");
    config.headers["Accept"] = "application/json";

    const formData = {
      items: optionalSelectedItems.map((item) => {
        return {
          id: item.variantData.id,
          quantity: quantity,
          properties: {
            _included_in_bundle: this.bundleId,
          },
        };
      }),
      sections: sections,
      sections_url: sectionsUrl,
    };

    config.body = JSON.stringify(formData);

    return fetch(`${theme.routes.cart_add_url}`, config).then((response) =>
      response.json()
    );
  }

  onItemClick(item) {
    if (item.isSelected) {
      this.nextAction = {
        action: "CHANGE",
        item: item,
      };
    } else {
      this.nextAction = {
        action: "SELECT",
        item: item,
      };
    }

    this.bundleDrawer?.show();
  }

  onVariantChange(event) {
    this.variantData = event.detail.variant;
    this.updatePrice();
    this.updateBuyButton();
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.querySelector("#bundle-builder-variant-data").textContent
      );
    return this.variantData;
  }

  get quantitySelector() {
    return this.closest(".product__info").querySelector(".quantity-selector");
  }

  updatePrice() {
    const optionalSelectedItems = this.items.filter(
      (item) => item.isOptional && item.isSelected
    );
    const optionalItemsPrice = optionalSelectedItems.reduce((total, item) => {
      return total + item.variantData.price;
    }, 0);
    const optionalItemsComparePrice = optionalSelectedItems.reduce(
      (total, item) => total + item.variantData.compare_at_price,
      0
    );

    const variantData = this.getVariantData();

    const totalPrice = variantData.price + optionalItemsPrice;
    const totalComparePrice =
      variantData.compare_at_price + optionalItemsComparePrice;

    if (this.regularPriceElement) {
      this.regularPriceElement.innerText = shopifyFormatCurrency(
        totalPrice,
        theme.bundleBuilderStrings.moneyFormat
      );
    }

    if (this.comparePriceElement) {
      this.comparePriceElement.innerText = shopifyFormatCurrency(
        totalComparePrice,
        theme.bundleBuilderStrings.moneyFormat
      );
    }

    if (
      !this.saleBadgeElement ||
      this.saleBadgeElement.classList.contains("badge--onsale--label")
    )
      return;

    let savedAmount;

    if (this.saleBadgeElement.classList.contains("badge--onsale--dollar")) {
      savedAmount = shopifyFormatCurrency(
        totalComparePrice - totalPrice,
        theme.bundleBuilderStrings.moneyFormat
      );
    } else {
      savedAmount =
        String(
          Math.round(
            ((totalComparePrice - totalPrice) / totalComparePrice) * 100
          )
        ) + "%";
    }

    this.saleBadgeElement.innerText = theme.variantStrings.save_html.replace(
      "{{ saved_amount }}",
      savedAmount
    );
  }

  get saleBadgeElement() {
    return this.closest(".product__info").querySelector(
      ".product__price .badge--onsale"
    );
  }

  get productForm() {
    return this.closest(".product__info").querySelector(".product-form");
  }

  get regularPriceElement() {
    return this.closest(".product__info").querySelector(
      ".product__price .price__regular"
    );
  }

  get comparePriceElement() {
    return this.closest(".product__info").querySelector(
      ".product__price .price__sale"
    );
  }

  onItemRemove(item) {
    // The item was already reset

    // Remove optional items that are not selected but leave one if none are selected
    const optionalNonSelectedItems = this.items.filter(
      (item) => item.isOptional && !item.isSelected
    );

    if (optionalNonSelectedItems.length >= 2) {
      optionalNonSelectedItems.forEach((item, index) => {
        if (index === optionalNonSelectedItems.length - 1) return;
        item.remove();
      });
    } else if (optionalNonSelectedItems.length === 1) {
      // If there is only one optional item, move it to the last position
      this.listElement.appendChild(optionalNonSelectedItems[0]);
    }

    const selectedNotPreselectedItems = this.items.filter(
      (item) => item.isSelected && !item.isPreselected
    );

    if (selectedNotPreselectedItems.length === 0) {
      this.alertElement.setAttribute("hidden", "true");
    }

    this.updateProgress();
    this.updatePrice();
    this.updateBuyButton();
    this.saveState();
  }

  updateProgress() {
    this.progressElement.innerText = theme.bundleBuilderStrings.progress.label
      .replace("{{selected_count}}", this.selectedCount)
      .replace("{{total_count}}", this.totalCount);
  }

  updateBuyButton() {
    if (this.selectedCount === this.totalCount) {
      this.toggleBuyButton(false, "");
    } else {
      this.toggleBuyButton(
        true,
        theme.bundleBuilderStrings.buy_button.disabled
      );
    }
  }

  toggleBuyButton(disable = true, text) {
    const buyButton = this.productForm.querySelector('[name="add"]');
    const buyButtonText = this.productForm.querySelector(
      '[name="add"] > .btn-text'
    );
    const buyButtonTextChild = this.productForm.querySelector(
      '[name="add"] > .btn-text span'
    );
    if (!buyButton) return;

    if (disable) {
      buyButton.setAttribute("disabled", "");
      if (text) {
        (buyButtonTextChild || buyButtonText).innerText = text;
      }
    } else {
      buyButton.removeAttribute("disabled");
      (buyButtonTextChild || buyButtonText).innerText =
        buyButton.dataset.preOrder === "true"
          ? theme.variantStrings.preOrder
          : theme.variantStrings.addToCart;
    }
  }

  get maxOptionalItems() {
    return (this._maxOptionalItems = parseInt(
      this._maxOptionalItems || this.dataset.maxOptionalCount || 0
    ));
  }

  get totalCount() {
    return (this._totalCount = parseInt(
      this._totalCount || parseInt(this.dataset.totalCount) || 0
    ));
  }

  get items() {
    return Array.from(this.querySelectorAll(".bundle-item"));
  }

  get itemListElement() {
    return this.querySelector(".bundle-item-list");
  }

  get bundleDrawer() {
    return document.querySelector("bundle-drawer");
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  onProductSubmit(event) {
    if (!this.nextAction) return;

    const variant = event.detail.variant;

    switch (this.nextAction.action) {
      case "CHANGE":
        this.nextAction.item.variantData = variant;
        break;
      case "SELECT":
        const nonSelectedItems = this.items.filter((item) => !item.isSelected);

        const firstNonSelectedItem =
          nonSelectedItems.length > 0
            ? nonSelectedItems[0]
            : this.nextAction.item;

        firstNonSelectedItem.variantData = variant;

        if (nonSelectedItems.length > 1) {
          break;
        }

        const optionalItems = this.items.filter((item) => item.isOptional);
        if (optionalItems.length < this.maxOptionalItems) {
          const clone = optionalItems[0].cloneNode(true);
          this.listElement.appendChild(clone);
          clone.reset();
        }
        break;
    }

    this.updateProgress();
    this.updatePrice();
    this.updateBuyButton();
    this.alertElement?.removeAttribute("hidden");

    this.saveState();
  }

  get alertElement() {
    return this.querySelector(".bundle-alert");
  }

  get progressElement() {
    return this.querySelector(".bundle-progress");
  }

  get listElement() {
    return this.querySelector(".bundle-item-list");
  }
}
customElements.define("bundle-builder", BundleBuilder);

class BundleBuilderItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.isPreselected) {
      return;
    }

    this.abortController = new AbortController();

    this.previewElement.addEventListener("click", this.onItemClick.bind(this), {
      signal: this.abortController.signal,
    });

    this.removeButton.addEventListener("click", this.onRemoveClick.bind(this), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  onItemClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.bundleBuilder.onItemClick(this);
  }

  onRemoveClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    this.reset();
    this.bundleBuilder.onItemRemove(this);
  }

  reset() {
    console.log("reset");
    this._variantData = null;
    this.querySelector('[type="application/json"]')?.remove();
    this.isSelected = false;
    this.titleElement.innerText = theme.bundleBuilderStrings.title[
      this.type
    ].replace("{{index}}", String(this.index).padStart(2, "0"));
    this.imagePlaceholderElement?.removeAttribute("hidden");
    this.imageElement?.remove();
    this.removeButton?.setAttribute("hidden", "true");
    this.priceElement?.setAttribute("hidden", "true");
    this.comparePriceElement?.setAttribute("hidden", "true");
  }

  get variantData() {
    if (this._variantData) return this._variantData;

    const scriptElement = this.querySelector('[type="application/json"]');
    if (!scriptElement) return null;

    const variantData = JSON.parse(scriptElement.textContent);
    this._variantData = variantData;
    return variantData;
  }

  set variantData(value) {
    this._variantData = value;

    let scriptElement = this.querySelector('[type="application/json"]');
    if (!scriptElement) {
      scriptElement = document.createElement("script");
      scriptElement.type = "application/json";
      this.appendChild(scriptElement);
    }

    scriptElement.textContent = JSON.stringify(value);

    console.log("variantData", this.variantData);

    this.isSelected = true;

    if (this.titleElement) {
      this.titleElement.innerText = this.variantData.name;
    }

    if (!this.imageElement) {
      const imageElement = document.createElement("img");
      this.imageWrapperElement.appendChild(imageElement);
    }

    try {
      const url = new URL("https:" + this.variantData.featured_image?.src);
      url.searchParams.set("width", "200");
      this.imageElement.src = url.toString();
    } catch (error) {
      console.error("Error setting image src", error);
    }

    this.imageElement.alt = this.variantData.featured_image?.alt;

    if (this.priceElement) {
      this.priceElement.innerText = shopifyFormatCurrency(
        this.variantData.price,
        theme.bundleBuilderStrings.moneyFormat
      );
    }

    if (this.comparePriceElement && this.variantData.compare_at_price) {
      this.comparePriceElement.innerText = shopifyFormatCurrency(
        this.variantData.compare_at_price,
        theme.bundleBuilderStrings.moneyFormat
      );

      if (this.variantData.compare_at_price > this.variantData.price) {
        this.comparePriceElement.removeAttribute("hidden");
      }
    }

    this.removeButton?.removeAttribute("hidden");
    this.imagePlaceholderElement?.setAttribute("hidden", "true");
    this.imageElement?.removeAttribute("hidden");
    this.priceElement?.removeAttribute("hidden");
  }

  get type() {
    return this.getAttribute("data-type");
  }

  get index() {
    return parseInt(this.getAttribute("data-index"));
  }

  get isSelected() {
    return (this._isSelected =
      this._isSelected ||
      this.isPreselected ||
      this.classList.contains("bundle-item--selected"));
  }

  set isSelected(value) {
    this._isSelected = value;
    this.classList.toggle("bundle-item--selected", value);
  }

  get isPreselected() {
    return this.type === "preselected";
  }

  get isIncluded() {
    return this.type === "included";
  }

  get isOptional() {
    return this.type === "optional";
  }

  get isFree() {
    return this.type === "free";
  }

  get bundleBuilder() {
    return this.closest("bundle-builder");
  }

  get previewElement() {
    return this.querySelector(".bundle-item__preview");
  }

  get removeButton() {
    return this.querySelector(".bundle-item__remove");
  }

  get titleElement() {
    return this.querySelector(".bundle-item__title");
  }

  get badgeElement() {
    return this.querySelector(".bundle-item__badge");
  }

  get priceElement() {
    return this.querySelector(".bundle-item__price");
  }

  get comparePriceElement() {
    return this.querySelector(".bundle-item__compare-price");
  }

  get imageWrapperElement() {
    return this.querySelector(".bundle-item__image");
  }

  get imagePlaceholderElement() {
    return this.querySelector(".bundle-item__image .icon");
  }

  get imageElement() {
    return this.querySelector(".bundle-item__image img");
  }
}
customElements.define("bundle-builder-item", BundleBuilderItem);

class BundleDrawerItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.querySelector(".bundle-item__preview").addEventListener(
      "click",
      this.onItemClick.bind(this),
      {
        signal: this.abortController.signal,
      }
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get bundleBuilder() {
    return document.querySelector("bundle-builder");
  }

  get bundleDrawer() {
    return document.querySelector("bundle-drawer");
  }

  get hasOnlyDefaultVariant() {
    return (this._hasOnlyDefaultVariant =
      this._hasOnlyDefaultVariant || this.variantData?.length === 1);
  }

  get variantData() {
    return (this._variantData =
      this._variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent));
  }

  onItemClick(event) {
    if (this.hasOnlyDefaultVariant) {
      this.bundleBuilder?.dispatchEvent(
        new CustomEvent("bundle:product:submit", {
          bubbles: true,
          detail: { variant: this.variantData[0] },
        })
      );

      this.bundleDrawer?.hide();
    }
  }
}
customElements.define("bundle-drawer-item", BundleDrawerItem);

/**
 * Formats a number of cents into a currency string using a Shopify format
 * string.
 *
 * https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options
 *
 * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 *
 * @param cents - The number of cents to format.
 * @param formatString - The format string to use.
 * @returns The formatted currency string.
 */
function shopifyFormatCurrency(cents, formatString) {
  const placeholderRegex = /{{\s*(\w+)\s*}}/;

  /**
   * Formats a number of cents into a currency string using the provided
   * precision, thousands separator, and decimal separator.
   * @param number - The number of cents to format.
   * @param precision - The number of decimal places to include.
   * @param thousands - The character to use as the thousands separator.
   * @param decimal - The character to use as the decimal separator.
   * @returns The formatted currency string.
   */
  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    const numString = (number / 100.0).toFixed(precision);
    const parts = numString.split(".");
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  return formatString.replace(placeholderRegex, (match, placeholder) => {
    switch (placeholder) {
      case "amount":
        // Ex.	1,134.65
        return formatWithDelimiters(cents, 2);
      case "amount_no_decimals":
        // Ex. 1,135
        return formatWithDelimiters(cents, 0);
      case "amount_with_comma_separator":
        // Ex. 1.134,65
        return formatWithDelimiters(cents, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator":
        // Ex. 1.135
        return formatWithDelimiters(cents, 0, ".", ",");
      case "amount_with_apostrophe_separator":
        // Ex. 1'134.65
        return formatWithDelimiters(cents, 2, "'", ".");
      case "amount_no_decimals_with_space_separator":
        // Ex. 1 135
        return formatWithDelimiters(cents, 0, " ");
      case "amount_with_space_separator":
        // 1 134,65
        return formatWithDelimiters(cents, 2, " ", ",");
      case "amount_with_period_and_space_separator":
        // 1 134.65
        return formatWithDelimiters(cents, 2, " ", ".");
      default:
        return match;
    }
  });
}
